import { useCallback, useEffect, useRef, useState } from "react";
import { Eye, Pencil, Plus, Trash2, AlertCircle, RefreshCw, X, BarChart2, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { addAmenities, addPartner, addPartnerBannerImage, addSports, deleteAmenity, deletePartner, deleteSport, getAllCities, getAllPartner, getAmenities, getBannerByPartner, getPartnerById, getSport, updatePartner, uploadFile, uploadImage } from "../service/api";
import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";
import { useNavigate } from "react-router-dom";
import { TransformComponent, TransformWrapper } from "react-zoom-pan-pinch";
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import QRCode from "react-qr-code";
import { PDFDownloadLink } from "@react-pdf/renderer";
import Qrcode from "./Qrcode";
import PartnerTurfSlotsModal from "../components/PartnerTurfSlotsModal";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Textarea } from "../components/ui/textarea";
import { Card, CardContent } from "../components/ui/card";
import { Badge } from "../components/ui/badge";
import {
    Table, TableBody, TableCell, TableHead, TableHeader, TableRow,
} from "../components/ui/table";
import {
    Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle,
} from "../components/ui/dialog";
import { TablePagination } from "../components/ui/pagination";
import { Switch } from "../components/ui/switch";

const animatedComponents = makeAnimated();

const containerStyle = { width: '100%', height: '300px' };
const initialCenter = { lat: 21.73672367971321, lng: 72.14494887566025 };

const defaultPartnerFormValues = {
    name: '', email: '', password: '', phone: '', address: '',
    latitude: '', longitude: '', is_active: false, logo: '',
    description: '', weather: '', city_id: '', is_sponsered: false,
};

const Partners = () => {
    const navigate = useNavigate();
    const [partners, setPartners] = useState<any>([]);
    const [addModal, setAddModal] = useState(false);
    const [viewModal, setViewModal] = useState(false);
    const [errors, setErrors] = useState<{ [key: string]: string }>({});
    const [bannerImage, setBannerImage] = useState<any[]>([]);
    const [amenities, setAmenities] = useState<any>([]);
    const [sports, setSports] = useState<any>([]);
    const [map, setMap] = useState(null);
    const [selectedLocation, setSelectedLocation] = useState<{ lat: number; lng: number } | null>(null);
    const [placeName, setPlaceName] = useState<string | null>(null);
    const [mode, setMode] = useState('add');
    const [formValues, setFormValues] = useState(defaultPartnerFormValues);
    const [deleteModal, setDeleteModal] = useState(false);
    const [deletePartnerr, setDeletePartnerr] = useState<any>();
    const [editPartnerBanner, setEditPartnerBanner] = useState<any>();
    const [bannerDetails, setBannerDetails] = useState<any>();
    const [cities, setCities] = useState([]);
    const [amenityFormValues, setAmenityFormValues] = useState({ name: '', image: '' });
    const [sportFormValues, setSportFormValues] = useState({ name: '', image: '' });
    const [limit] = useState(15);
    const [offset, setOffset] = useState(1);
    const [pagination, setPagination] = useState<any>({});
    const [latitude, setLatitude] = useState<any>(null);
    const [longitude, setLongitude] = useState<any>(null);
    const [selectedImage, setSelectedImage] = useState<any>(null);
    const [isOpen, setIsOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [selectedAmenitiesIds, setSelectedAmenitiesIds] = useState<any[]>([]);
    const [selectedSportsIds, setSelectedSportsIds] = useState<any[]>([]);
    const [selectedAmenities, setSelectedAmenities] = useState<any[]>([]);
    const [selectedSports, setSelectedSports] = useState<any[]>([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [turfSlotsModalOpen, setTurfSlotsModalOpen] = useState(false);
    const [turfSlotsPartner, setTurfSlotsPartner] = useState<{ id: number; name: string } | null>(null);

    const openTurfSlotsModal = (item: any) => {
        setTurfSlotsPartner({ id: item.id, name: item.name ?? `Partner #${item.id}` });
        setTurfSlotsModalOpen(true);
    };

    useEffect(() => {
        getCities();
        getAllAmenities();
        getAllSports();
    }, []);

    const getAllAmenities = async () => {
        let res = await getAmenities();
        const formatted = res.data.data.map((amenity: any) => ({ value: amenity.id, label: amenity.name }));
        setAmenities(formatted);
    };

    const getAllSports = async () => {
        let res = await getSport();
        const formatted = res.data.data.map((sport: any) => ({ value: sport.id, label: sport.name }));
        setSports(formatted);
    };

    useEffect(() => { getUserLocation(); }, []);

    useEffect(() => {
        if (latitude !== null && longitude !== null) {
            getPartners(offset);
        }
    }, [offset, latitude, longitude]);

    const getCities = async () => {
        let res = await getAllCities();
        setCities(res.data.data);
    };

    const getUserLocation = () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    setLatitude(position.coords.latitude);
                    setLongitude(position.coords.longitude);
                },
                () => {
                    setLatitude(initialCenter.lat);
                    setLongitude(initialCenter.lng);
                }
            );
        } else {
            setLatitude(initialCenter.lat);
            setLongitude(initialCenter.lng);
        }
    };

    const getPartners = async (offsetVal: any) => {
        try {
            setLoading(true);
            const res = await getAllPartner(limit, offsetVal);
            setPartners(res.data.data);
            setPagination(res.data.pagination);
        } catch (error) {
        } finally {
            setLoading(false);
        }
    };

    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: "AIzaSyCaiPJzCsaqT_2W2PIcmZZ0nU8PPto1oGg"
    });

    const onLoad = useCallback(function callback(map: any) { setMap(map); }, []);
    const onUnmount = useCallback(function callback() { setMap(null); }, []);

    const mapOptions = { fullscreenControl: false, mapTypeControl: false, streetViewControl: false };

    const onMapClick = (event: any) => {
        const lat = event.latLng.lat();
        const lng = event.latLng.lng();
        setSelectedLocation({ lat, lng });
        const geocoder = new window.google.maps.Geocoder();
        geocoder.geocode({ location: { lat, lng } }, (results: any, status: any) => {
            if (status === 'OK' && results[0]) setPlaceName(results[0].formatted_address);
            else setPlaceName('Unknown location');
        });
        setFormValues((prev) => ({ ...prev, latitude: lat.toString(), longitude: lng.toString() }));
    };

    const openModal = async (item: any, data: any) => {
        if (data === 'update') {
            const res = await getPartnerById({ id: item.id });
            const d = res.data.data;
            setFormValues({
                name: d?.name ?? "", email: d?.email ?? "", password: "",
                phone: d?.phone != null ? String(d.phone) : "",
                address: d?.address ?? "",
                latitude: d?.latitude != null ? String(d.latitude) : "",
                longitude: d?.longitude != null ? String(d.longitude) : "",
                is_active: d?.is_active === 1 ? true : false,
                logo: d?.logo ?? "", description: d?.description ?? "",
                weather: d?.weather ?? "",
                city_id: d?.city_id != null ? String(d.city_id) : "",
                is_sponsered: Boolean(d?.is_sponsered),
            });
            setBannerImage(Array.isArray(d?.bannerImages) ? d.bannerImages : []);
            const amenitiesData = d?.amenity_id || [];
            const selAmenities = amenitiesData.map((a: any) => ({ value: a.value, label: a.label }));
            getAllAmenities();
            setSelectedAmenities(selAmenities);
            setSelectedAmenitiesIds(selAmenities);
            const sportsData = d?.sport_id || [];
            const selSports = sportsData.map((s: any) => ({ value: s.value, label: s.label }));
            getAllSports();
            setSelectedSports(selSports);
            setSelectedSportsIds(selSports);
            setEditPartnerBanner(d?.id);
            setMode('update');
        } else {
            setFormValues(defaultPartnerFormValues);
            setBannerImage([]);
            setSelectedAmenities([]);
            setSelectedSports([]);
            setSelectedAmenitiesIds([]);
            setSelectedSportsIds([]);
            setEditPartnerBanner(undefined);
            setMode('add');
        }
        setAddModal(true);
    };

    const handleDelete = async (data: any) => {
        setDeleteModal(true);
        setDeletePartnerr(data.id);
    };

    const deletePartners = async () => {
        try {
            await deletePartner({ id: deletePartnerr });
            toast.success("Partner deleted successfully");
            setDeleteModal(false);
            getPartners(offset);
        } catch {
            toast.error("Failed to delete partner. Please try again.");
        }
    };

    const handleView = async (data: any) => {
        let res = await getPartnerById({ id: data.id });
        setViewModal(true);
        setBannerDetails(res.data.data);
    };

    const validateForm = () => {
        const newErrors: { [key: string]: string } = {};
        const str = (v: unknown) => (v == null ? "" : String(v)).trim();
        if (!str(formValues.name)) newErrors.name = "Name is required";
        const email = str(formValues.email);
        if (!email) newErrors.email = "Email is required";
        else if (!/\S+@\S+\.\S+/.test(email)) newErrors.email = "Email is invalid";
        if (mode === "add" && !str(formValues.password)) newErrors.password = "Password is required";
        const phone = str(formValues.phone);
        if (!phone) newErrors.phone = "Phone number is required";
        else if (!/^\d{10}$/.test(phone)) newErrors.phone = "Phone number must be 10 digits";
        if (!str(formValues.address)) newErrors.address = "Address is required";
        if (!str(formValues.description)) newErrors.description = "Description is required";
        if (!str(formValues.weather)) newErrors.weather = "Weather is required";
        if (!str(formValues.city_id)) newErrors.city_id = "City is required";
        if (mode === "add" && (!bannerImage || bannerImage.length === 0)) newErrors.bannerImage = "Partner banner image is required";
        const logoStr = formValues.logo == null ? "" : String(formValues.logo);
        if (mode === "add" && logoStr.length === 0) newErrors.image = "Logo is required";
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (event: any) => {
        event.preventDefault();
        if (!validateForm()) return;
        setSubmitting(true);
        try {
            const base = {
                name: formValues.name, email: formValues.email,
                phone: formValues.phone, address: formValues.address,
                latitude: formValues.latitude, longitude: formValues.longitude,
                logo: formValues.logo, is_active: formValues.is_active,
                description: formValues.description, weather: formValues.weather,
                city_id: formValues.city_id, is_sponsered: formValues.is_sponsered,
            };
            if (mode === 'add') {
                const body = {
                    ...base,
                    password: formValues.password,
                    amenity_id: selectedAmenitiesIds,
                    sport_id: selectedSportsIds,
                };
                const result = await addPartner(body);
                await addPartnerBannerImage({ partnerId: result.data.data.insertId, imageUrl: bannerImage });
                toast.success("Partner added successfully");
                getPartners(offset);
                setAddModal(false);
            } else {
                const selAmenIds = selectedAmenities.map((a: any) => ({ value: a.value, label: a.label }));
                const selSportIds = selectedSports.map((s: any) => ({ value: s.value, label: s.label }));
                const passwordTrimmed = String(formValues.password ?? "").trim();
                const updateBody: Record<string, unknown> = {
                    ...base,
                    id: editPartnerBanner,
                    amenity_id: selAmenIds,
                    sport_id: selSportIds,
                    imageUrl: bannerImage && bannerImage.length > 0 ? bannerImage : undefined,
                };
                if (passwordTrimmed) updateBody.password = passwordTrimmed;
                const res = await updatePartner(updateBody);
                if (res.data?.status === false) {
                    toast.error(res.data?.message || "Failed to update partner");
                } else {
                    toast.success("Partner updated successfully");
                    getPartners(offset);
                    setAddModal(false);
                    setBannerImage([]);
                    setSelectedAmenities([]);
                    setSelectedSports([]);
                }
            }
        } catch (error: any) {
            toast.error(error?.response?.data?.message || "Something went wrong. Please try again.");
        } finally {
            setSubmitting(false);
        }
    };

    const handleInputChange = (e: any) => {
        const { name, value } = e.target;
        setFormValues({ ...formValues, [name]: value });
        setErrors({ ...errors, [name]: "" });
    };

    const handleLogoChange = async (e: any) => {
        const file = e.target.files?.[0];
        if (!file) return;
        const formData = new FormData();
        formData.append('file', file, file.name);
        try {
            const response = await uploadImage(formData);
            setFormValues({ ...formValues, logo: response.data.files[0] });
        } catch (error) {
        }
    };

    const handleImages = async (e: any) => {
        const files = e.target.files;
        if (!files.length) return;
        const formData = new FormData();
        for (let i = 0; i < files.length; i++) formData.append('file', files[i], files[i].name);
        try {
            const response = await uploadFile(formData);
            setBannerImage(response.data.files);
            setErrors({});
        } catch (error) {
        }
    };

    const handleSelectChange = (selectedOptions: any) => {
        const ids = selectedOptions.map((option: any) => ({ value: option.value, label: option.label }));
        setSelectedAmenitiesIds(ids);
        setSelectedAmenities(selectedOptions);
    };

    const handleSelectChangeSport = (selectedOptions: any) => {
        const ids = selectedOptions.map((option: any) => ({ value: option.value, label: option.label }));
        setSelectedSportsIds(ids);
        setSelectedSports(selectedOptions);
    };

    const analytics = (data: any) => {
        navigate('/analytics', { state: { id: data.id, name: data.name } });
    };

    const openZoomModal = (imageUrl: any) => {
        setIsOpen(true);
        setSelectedImage(imageUrl);
    };

    const getImageUrl = (image: any) => {
        if (!image) return "";
        if (typeof image === "string") return image;
        if (typeof image === "object") return image.imageUrl || image.url || "";
        return "";
    };

    const filteredPartners = partners?.filter((partner: any) =>
        partner?.name?.toLowerCase()?.includes(searchQuery.toLowerCase()) ||
        partner?.email?.toLowerCase()?.includes(searchQuery.toLowerCase()) ||
        partner?.phone?.includes(searchQuery)
    );

    const WEATHER_OPTIONS = ["Fog","Hurricane","Wind","Cloudy","Forecast","Cloud","Flood","Clear","Rain","Snow","Cold","Heat","Hail","Drizzle","Frost","Climate","Blizzard","Storm","Sun","Lightning","Humidity","Drought","Breeze","Precipitation"];

    return (
        <div className="w-full max-w-7xl mx-auto pb-8 space-y-5 lg:space-y-6">
            {/* Header card */}
            <Card>
                <CardContent className="p-4 sm:p-5 flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
                    <div className="min-w-0">
                        <h1 className="text-2xl font-semibold text-foreground">Partners</h1>
                        <p className="mt-1 text-sm text-muted-foreground max-w-xl">
                            Manage partner profiles, banners, turfs, and onboarding details.
                        </p>
                    </div>
                    <div className="flex flex-col gap-3 sm:flex-row sm:flex-wrap sm:items-center w-full lg:w-auto">
                        <div className="relative w-full sm:min-w-[240px] sm:max-w-xs">
                            <Input
                                type="text"
                                placeholder="Search name, email or phone"
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                            />
                        </div>
                        <Button size="sm" onClick={() => openModal([], 'add')}>
                            <Plus className="h-4 w-4 mr-1" /> Add partner
                        </Button>
                    </div>
                </CardContent>
            </Card>

            {/* Partners list */}
            {loading ? (
                <div className="flex items-center justify-center py-20">
                    <div className="h-8 w-8 animate-spin rounded-full border-2 border-primary border-t-transparent" />
                </div>
            ) : (
                <div className="space-y-4">
                    {/* Mobile card view */}
                    <div className="lg:hidden space-y-3">
                        {filteredPartners?.length === 0 ? (
                            <Card><CardContent className="p-4 text-center text-sm text-muted-foreground font-medium">Partner not available.</CardContent></Card>
                        ) : (
                            filteredPartners?.map((item: any) => (
                                <Card key={item.id}>
                                    <CardContent className="p-3">
                                        <div className="flex items-center gap-2.5">
                                            <img
                                                src={item.logo}
                                                alt={item.name}
                                                className="h-12 w-12 rounded-full object-cover border shrink-0"
                                                onError={(e) => { e.currentTarget.src = "/wood-blog-placeholder.jpg"; }}
                                            />
                                            <div className="flex-1 min-w-0">
                                                <p className="text-sm font-semibold truncate">{item.name}</p>
                                                <p className="text-xs text-muted-foreground truncate">{item.email}</p>
                                                {item.is_sponsered === 1 && <p className="text-green-600 text-xs font-semibold">Sponsored</p>}
                                            </div>
                                            <Badge variant={item.is_active === 1 ? "default" : "destructive"} className="shrink-0">
                                                {item.is_active === 1 ? "Active" : "Inactive"}
                                            </Badge>
                                        </div>
                                        <div className="grid grid-cols-2 gap-2 text-xs text-muted-foreground mt-2">
                                            <p><span className="font-semibold">Phone:</span> {item.phone}</p>
                                            <p><span className="font-semibold">City:</span> {item.cityName}</p>
                                            <p><span className="font-semibold">Boxes:</span> {item.boxCount}</p>
                                        </div>
                                        <div className="flex flex-wrap justify-end gap-1 mt-3">
                                            <Button type="button" size="sm" variant="outline" className="h-7 text-xs" onClick={() => openTurfSlotsModal(item)}>
                                                Turfs &amp; slots ({item.boxCount})
                                            </Button>
                                            <Button size="sm" variant="ghost" className="h-7 text-xs" onClick={() => handleView(item)}>View</Button>
                                            <Button size="sm" variant="ghost" className="h-7 text-xs" onClick={() => openModal(item, 'update')}>Edit</Button>
                                            <Button size="sm" variant="ghost" className="h-7 text-xs" onClick={() => analytics(item)}>Analytics</Button>
                                            <Button size="sm" variant="ghost" className="h-7 text-xs text-destructive hover:text-destructive" onClick={() => handleDelete(item)}>Delete</Button>
                                        </div>
                                    </CardContent>
                                </Card>
                            ))
                        )}
                    </div>

                    {/* Desktop table view */}
                    <Card className="hidden lg:block overflow-hidden">
                        <div className="overflow-x-auto">
                            <Table>
                                <TableHeader>
                                    <TableRow className="bg-muted/30 text-xs uppercase tracking-wide">
                                        <TableHead className="w-12">Id</TableHead>
                                        <TableHead className="w-16">Logo</TableHead>
                                        <TableHead>Name</TableHead>
                                        <TableHead>Phone</TableHead>
                                        <TableHead>Status</TableHead>
                                        <TableHead>City</TableHead>
                                        <TableHead className="text-right min-w-[12rem]">Actions</TableHead>
                                    </TableRow>
                                </TableHeader>
                                <TableBody>
                                    {filteredPartners?.length === 0 ? (
                                        <TableRow>
                                            <TableCell colSpan={7} className="text-center py-10 text-muted-foreground font-medium">
                                                Partner not available.
                                            </TableCell>
                                        </TableRow>
                                    ) : (
                                        filteredPartners?.map((item: any, index: any) => (
                                            <TableRow key={item.id}>
                                                <TableCell className="text-muted-foreground">{(offset - 1) * limit + index + 1}</TableCell>
                                                <TableCell>
                                                    <img
                                                        src={item.logo}
                                                        alt=""
                                                        className="h-12 w-12 rounded-full object-cover border-2"
                                                        onError={(e) => { e.currentTarget.src = "/wood-blog-placeholder.jpg"; }}
                                                    />
                                                </TableCell>
                                                <TableCell className="max-w-[180px]">
                                                    <div className="font-medium truncate">{item.name}</div>
                                                    {item.is_sponsered === 1 && <p className="text-green-600 text-xs font-semibold">Sponsored</p>}
                                                </TableCell>
                                                <TableCell className="tabular-nums">{item.phone}</TableCell>
                                                <TableCell>
                                                    <span className={item.is_active === 1 ? 'text-green-600 font-bold text-sm' : 'text-red-500 font-bold text-sm'}>
                                                        {item.is_active === 1 ? "Active" : "Not active"}
                                                    </span>
                                                </TableCell>
                                                <TableCell>{item.cityName}</TableCell>
                                                <TableCell className="text-right">
                                                    <div className="flex flex-wrap items-center justify-end gap-1">
                                                        <Button type="button" size="sm" variant="outline" className="h-7 text-xs" onClick={() => openTurfSlotsModal(item)}>
                                                            Turfs
                                                        </Button>
                                                        <Button type="button" variant="ghost" size="icon" className="h-8 w-8" onClick={() => openModal(item, 'update')}>
                                                            <Pencil className="h-4 w-4 text-blue-600" />
                                                        </Button>
                                                        <Button type="button" variant="ghost" size="icon" className="h-8 w-8" onClick={() => handleView(item)}>
                                                            <Eye className="h-4 w-4" />
                                                        </Button>
                                                        <Button type="button" variant="ghost" size="icon" className="h-8 w-8" onClick={() => analytics(item)}>
                                                            <BarChart2 className="h-4 w-4 text-green-600" />
                                                        </Button>
                                                        <Button type="button" variant="ghost" size="icon" className="h-8 w-8 text-destructive hover:text-destructive" onClick={() => handleDelete(item)}>
                                                            <Trash2 className="h-4 w-4" />
                                                        </Button>
                                                    </div>
                                                </TableCell>
                                            </TableRow>
                                        ))
                                    )}
                                </TableBody>
                            </Table>
                        </div>
                    </Card>

                    {/* Pagination */}
                    <Card>
                        <CardContent className="py-3 px-4 sm:px-5 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                            <p className="text-xs sm:text-sm text-muted-foreground">
                                Showing <span className="font-semibold text-foreground">{filteredPartners?.length || 0}</span> partner{(filteredPartners?.length || 0) === 1 ? "" : "s"} on this page
                            </p>
                            {pagination?.last_page > 1 && (
                                <TablePagination
                                    currentPage={offset}
                                    totalPages={pagination?.last_page ?? 1}
                                    onPageChange={(page) => setOffset(page)}
                                />
                            )}
                        </CardContent>
                    </Card>
                </div>
            )}

            <PartnerTurfSlotsModal
                open={turfSlotsModalOpen}
                onClose={() => { setTurfSlotsModalOpen(false); setTurfSlotsPartner(null); }}
                partnerId={turfSlotsPartner?.id ?? null}
                partnerName={turfSlotsPartner?.name ?? ""}
            />

            {/* Add/Edit partner dialog */}
            <Dialog open={addModal} onOpenChange={setAddModal}>
                <DialogContent className="max-w-4xl max-h-[90vh] overflow-y-auto p-0">
                    <div className="sticky top-0 z-10 flex items-center justify-between border-b bg-background/95 backdrop-blur-sm px-6 py-4">
                        <div>
                            <DialogTitle>{mode === 'add' ? 'Add partner' : 'Edit partner'}</DialogTitle>
                            <DialogDescription className="mt-0.5">Fill in all the details for this partner profile.</DialogDescription>
                        </div>
                        <Button variant="ghost" size="icon" className="h-8 w-8" onClick={() => setAddModal(false)}>
                            <X className="h-4 w-4" />
                        </Button>
                    </div>
                    <div className="px-6 py-4">
                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                            <div className="space-y-1.5">
                                <Label>Name</Label>
                                <Input name="name" placeholder="Enter name" value={formValues.name} onChange={handleInputChange} />
                                {errors.name && <p className="text-destructive text-xs">{errors.name}</p>}
                            </div>
                            <div className="space-y-1.5">
                                <Label>Email</Label>
                                <Input type="email" name="email" placeholder="Enter email" value={formValues.email} onChange={handleInputChange} />
                                {errors.email && <p className="text-destructive text-xs">{errors.email}</p>}
                            </div>
                            <div className="space-y-1.5">
                                <Label>Password {mode === 'update' && <span className="text-muted-foreground font-normal">(leave blank to keep)</span>}</Label>
                                <Input type="password" name="password" placeholder="Enter password" value={formValues.password} onChange={handleInputChange} />
                                {errors.password && <p className="text-destructive text-xs">{errors.password}</p>}
                            </div>
                            <div className="space-y-1.5">
                                <Label>Phone</Label>
                                <Input name="phone" placeholder="10-digit number" value={formValues.phone} onChange={handleInputChange} />
                                {errors.phone && <p className="text-destructive text-xs">{errors.phone}</p>}
                            </div>
                            <div className="space-y-1.5">
                                <Label>Address</Label>
                                <Textarea name="address" placeholder="Enter address" value={formValues.address} onChange={handleInputChange} />
                                {errors.address && <p className="text-destructive text-xs">{errors.address}</p>}
                            </div>
                            <div className="space-y-1.5">
                                <Label>Description</Label>
                                <Textarea name="description" placeholder="Enter description" value={formValues.description} onChange={handleInputChange} />
                                {errors.description && <p className="text-destructive text-xs">{errors.description}</p>}
                            </div>
                            <div className="flex items-center gap-3">
                                <Switch
                                    id="partner-active"
                                    checked={formValues.is_active}
                                    onCheckedChange={(checked) => setFormValues({ ...formValues, is_active: checked })}
                                />
                                <Label htmlFor="partner-active" className="cursor-pointer">Active</Label>
                            </div>
                            <div className="flex items-center gap-3">
                                <Switch
                                    id="partner-sponsored"
                                    checked={formValues.is_sponsered}
                                    onCheckedChange={(checked) => setFormValues({ ...formValues, is_sponsered: checked })}
                                />
                                <Label htmlFor="partner-sponsored" className="cursor-pointer">Sponsored</Label>
                            </div>
                            <div className="space-y-1.5">
                                <Label>Weather</Label>
                                <select
                                    className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
                                    value={formValues.weather}
                                    onChange={(e) => setFormValues({ ...formValues, weather: e.target.value })}
                                >
                                    <option value="">Select weather</option>
                                    {WEATHER_OPTIONS.map((w) => <option key={w}>{w}</option>)}
                                </select>
                                {errors.weather && <p className="text-destructive text-xs">{errors.weather}</p>}
                            </div>
                            <div className="space-y-1.5">
                                <Label>City</Label>
                                <select
                                    className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
                                    value={formValues.city_id}
                                    onChange={(e) => setFormValues({ ...formValues, city_id: e.target.value })}
                                >
                                    <option value="">Select city</option>
                                    {cities.map((item: any) => <option value={item.id} key={item.id}>{item.name}</option>)}
                                </select>
                                {errors.city_id && <p className="text-destructive text-xs">{errors.city_id}</p>}
                            </div>
                            <div className="space-y-1.5">
                                <Label>Logo image</Label>
                                <input
                                    type="file"
                                    onChange={handleLogoChange}
                                    className="block w-full text-sm text-muted-foreground file:mr-4 file:rounded-md file:border-0 file:bg-primary file:px-3 file:py-1.5 file:text-sm file:font-medium file:text-primary-foreground hover:file:bg-primary/90"
                                />
                                {formValues.logo && <img src={formValues.logo} alt="Logo preview" className="mt-2 max-h-24 rounded-md border" />}
                                {errors.image && <p className="text-destructive text-xs">{errors.image}</p>}
                            </div>
                            <div className="space-y-1.5">
                                <Label>Partner banner images</Label>
                                <input
                                    type="file"
                                    multiple
                                    onChange={handleImages}
                                    className="block w-full text-sm text-muted-foreground file:mr-4 file:rounded-md file:border-0 file:bg-primary file:px-3 file:py-1.5 file:text-sm file:font-medium file:text-primary-foreground hover:file:bg-primary/90"
                                />
                                {bannerImage?.length > 0 && (
                                    <div className="flex flex-wrap gap-2 mt-2">
                                        {bannerImage.map((url: any, index: any) => (
                                            <img key={index} src={getImageUrl(url)} alt={`Banner ${index + 1}`} className="max-h-20 rounded-md border" />
                                        ))}
                                    </div>
                                )}
                                {errors.bannerImage && <p className="text-destructive text-xs">{errors.bannerImage}</p>}
                            </div>
                            <div className="space-y-1.5">
                                <Label>Amenities</Label>
                                <Select
                                    closeMenuOnSelect={false}
                                    components={animatedComponents}
                                    isMulti
                                    options={amenities}
                                    value={selectedAmenities}
                                    onChange={handleSelectChange}
                                />
                            </div>
                            <div className="space-y-1.5">
                                <Label>Sports</Label>
                                <Select
                                    closeMenuOnSelect={false}
                                    components={animatedComponents}
                                    isMulti
                                    options={sports}
                                    value={selectedSports}
                                    onChange={handleSelectChangeSport}
                                />
                            </div>
                            <div className="lg:col-span-2 space-y-3">
                                {isLoaded && (
                                    <GoogleMap
                                        options={mapOptions}
                                        zoom={12}
                                        mapContainerStyle={containerStyle}
                                        center={initialCenter}
                                        onLoad={onLoad}
                                        onUnmount={onUnmount}
                                        onClick={onMapClick}
                                    >
                                        {formValues.latitude && formValues.longitude && (
                                            <Marker position={{ lat: parseFloat(formValues.latitude), lng: parseFloat(formValues.longitude) }} />
                                        )}
                                    </GoogleMap>
                                )}
                                {formValues.latitude && formValues.longitude && (
                                    <div className="grid grid-cols-2 gap-3">
                                        <div className="space-y-1.5">
                                            <Label>Latitude</Label>
                                            <Input type="text" value={formValues.latitude} onChange={(e) => setFormValues({ ...formValues, latitude: e.target.value })} />
                                        </div>
                                        <div className="space-y-1.5">
                                            <Label>Longitude</Label>
                                            <Input type="text" value={formValues.longitude} onChange={(e) => setFormValues({ ...formValues, longitude: e.target.value })} />
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="border-t bg-muted/20 px-6 py-4 flex flex-col-reverse sm:flex-row sm:justify-end gap-2">
                        <Button variant="ghost" onClick={() => setAddModal(false)} disabled={submitting}>Cancel</Button>
                        <Button onClick={handleSubmit} disabled={submitting}>
                            {submitting && <Loader2 className="h-4 w-4 mr-1.5 animate-spin" />}
                            {mode === 'add' ? 'Add partner' : 'Update partner'}
                        </Button>
                    </div>
                </DialogContent>
            </Dialog>

            {/* Delete confirmation dialog */}
            <Dialog open={deleteModal} onOpenChange={setDeleteModal}>
                <DialogContent className="max-w-sm">
                    <DialogHeader className="items-center text-center">
                        <AlertCircle className="h-12 w-12 text-destructive mx-auto mb-2" />
                        <DialogTitle>Delete this partner?</DialogTitle>
                        <DialogDescription>This cannot be undone.</DialogDescription>
                    </DialogHeader>
                    <DialogFooter className="flex-row justify-center gap-2 sm:justify-center">
                        <Button variant="outline" onClick={() => setDeleteModal(false)}>Cancel</Button>
                        <Button variant="destructive" onClick={deletePartners}>Delete</Button>
                    </DialogFooter>
                </DialogContent>
            </Dialog>

            {/* View partner dialog */}
            <Dialog open={viewModal} onOpenChange={setViewModal}>
                <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
                    <DialogHeader>
                        <DialogTitle>View partner details</DialogTitle>
                        <DialogDescription>Profile, banners, amenities, and sports for this partner.</DialogDescription>
                    </DialogHeader>
                    {bannerDetails && (
                        <div className="space-y-4">
                            <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-3 p-3 rounded-xl bg-muted/30">
                                <div className="flex items-center gap-3">
                                    <img
                                        src={bannerDetails?.logo}
                                        alt=""
                                        onError={(e) => { e.currentTarget.src = "/wood-blog-placeholder.jpg"; }}
                                        className="h-16 w-16 rounded-full object-cover border-2 shrink-0"
                                    />
                                    <div>
                                        <h2 className="text-sm font-bold">{bannerDetails?.name}</h2>
                                        <p className="text-sm text-muted-foreground">{bannerDetails?.email} · {bannerDetails?.phone}</p>
                                        <p className="text-sm text-muted-foreground"><span className="font-medium">Address:</span> {bannerDetails?.address} · <span className="font-medium">City:</span> {bannerDetails?.cityName}</p>
                                        <p className="text-sm text-muted-foreground"><span className="font-medium">Weather:</span> {bannerDetails?.weather}</p>
                                    </div>
                                </div>
                                <PDFDownloadLink
                                    document={<Qrcode data={bannerDetails} />}
                                    fileName={`${bannerDetails?.name}-QRCode.pdf`}
                                    className="shrink-0"
                                >
                                    <Button size="sm">Download QR</Button>
                                </PDFDownloadLink>
                            </div>

                            <div id="qrCodeContainer" style={{ display: 'none' }}>
                                <QRCode
                                    id="qrCode"
                                    value={`${bannerDetails?.id}` + bannerDetails?.name}
                                    bgColor="#FFFFFF"
                                    fgColor="#000000"
                                    style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                                    size={256}
                                />
                            </div>

                            <div>
                                <h3 className="text-base font-semibold mb-2">Banner images</h3>
                                <div className="flex gap-4 overflow-x-auto pb-2">
                                    {(bannerDetails?.bannerImages?.length ?? 0) === 0 ? (
                                        <p className="text-sm text-muted-foreground">Banner images not available.</p>
                                    ) : (
                                        bannerDetails?.bannerImages.map((item: any, index: any) => (
                                            <img
                                                key={index}
                                                src={item.imageUrl}
                                                alt=""
                                                className="h-32 w-48 object-contain rounded-lg border shrink-0 cursor-pointer"
                                                onClick={() => openZoomModal(item.imageUrl)}
                                                onError={(e) => { e.currentTarget.src = "/wood-blog-placeholder.jpg"; }}
                                            />
                                        ))
                                    )}
                                </div>
                            </div>

                            <div>
                                <h3 className="text-base font-semibold mb-2">Amenities</h3>
                                <div className="flex gap-4 overflow-x-auto pb-2">
                                    {bannerDetails?.amenity_id?.length === 0 ? (
                                        <p className="text-sm text-muted-foreground">Amenities not available.</p>
                                    ) : (
                                        bannerDetails?.amenity_id?.map((item: any, index: any) => (
                                            <div key={index} className="flex flex-col items-center shrink-0">
                                                <img
                                                    src={item.image}
                                                    alt={item.name}
                                                    className="h-12 w-12 object-contain cursor-pointer"
                                                    onClick={() => openZoomModal(item.image)}
                                                    onError={(e) => { e.currentTarget.src = "/wood-blog-placeholder.jpg"; }}
                                                />
                                                <p className="text-xs text-center mt-1">{item.label}</p>
                                            </div>
                                        ))
                                    )}
                                </div>
                            </div>

                            <div>
                                <h3 className="text-base font-semibold mb-2">Sports</h3>
                                <div className="flex gap-4 overflow-x-auto pb-2">
                                    {bannerDetails?.sport_id?.length === 0 ? (
                                        <p className="text-sm text-muted-foreground">Sports not available.</p>
                                    ) : (
                                        bannerDetails?.sport_id?.map((item: any, index: any) => (
                                            <div key={index} className="flex flex-col items-center shrink-0">
                                                <img
                                                    src={item.image}
                                                    alt=""
                                                    className="h-16 w-16 object-contain cursor-pointer"
                                                    onClick={() => openZoomModal(item.image)}
                                                    onError={(e) => { e.currentTarget.src = "/wood-blog-placeholder.jpg"; }}
                                                />
                                                <p className="text-xs text-center mt-1">{item.label}</p>
                                            </div>
                                        ))
                                    )}
                                </div>
                            </div>
                        </div>
                    )}
                </DialogContent>
            </Dialog>

            {/* Zoom image dialog */}
            <Dialog open={isOpen} onOpenChange={setIsOpen}>
                <DialogContent className="max-w-2xl">
                    <DialogHeader>
                        <DialogTitle>Image preview</DialogTitle>
                        <DialogDescription>Pinch or scroll to zoom in/out.</DialogDescription>
                    </DialogHeader>
                    {selectedImage && (
                        <TransformWrapper>
                            <TransformComponent>
                                <img
                                    src={selectedImage}
                                    alt="Enlarged"
                                    className="max-w-full max-h-[70vh] mt-2"
                                />
                            </TransformComponent>
                        </TransformWrapper>
                    )}
                </DialogContent>
            </Dialog>
        </div>
    );
};

export default Partners;
